export default __webpack_public_path__ + "static/media/close.49771a94.svg";